/*
 * File: DeletePeriodEnrollment.ts
 * Author: Austin Robinson
 * Date Created: 7/25/2023
 * Copyright (c) DrivingDoc 2023
 */

import { AxiosError } from 'axios';
import { createMutation } from 'react-query-kit';

import { ErrorResponse, privateApi } from 'api';
import { invalidateQueryKeys } from 'api/hooks/middlewares';

export type DeletePeriodEnrollmentParams = {
    coursePeriodId: string;
    studentId: string;
};

async function deletePeriodEnrollment(params: DeletePeriodEnrollmentParams | undefined): Promise<boolean> {
    if (params === undefined) {
        return false;
    }

    console.time('Delete Course Periods');
    // make api call
    await privateApi.delete(`${import.meta.env.VITE_API_BASE_URL}/courses/periods/deletePeriodEnrollment`, {

        data: params
    });
    // return the data object
    return true;
}

const useDeletePeriodEnrollment = createMutation<boolean, DeletePeriodEnrollmentParams, AxiosError<ErrorResponse>, unknown>({
    mutationFn: async (variables: DeletePeriodEnrollmentParams) => deletePeriodEnrollment(variables),
    use: [
        invalidateQueryKeys<boolean, DeletePeriodEnrollmentParams>((_data, variables) => [
            { queryKey: ['course_period', { id: variables.coursePeriodId }] },
            { queryKey: ['self_scheduled_course_period_count'] },
            { queryKey: ['student_course_enrollments'] },
            { queryKey: ['self_scheduled_course_periods'] },
            { queryKey: ['student_course_periods'] },
            { queryKey: ['student_ledger'] },
        ]),
    ],
});

export { deletePeriodEnrollment, useDeletePeriodEnrollment };
